import $ from "jquery";


// bootstrap
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';

// validation plugin
import "./js/vendors/jquery.validate.min";

// slick slider
import "./js/vendors/slick.min";

// main js
import "../src/js/main";
import "../src/js/internal";

// main scss
import "../src/css/main.scss";

export { $ };